import { IAbUseExperiment } from '../types/abUseExperiments';

export const BANNER_SIMILAR_OFFERS = 'banner_similar_offers_v1';

export enum EBannerSimilarOffersExperiment {
  A = 'A',
  B = 'B',
}

export function getBannerSimilarOffersExperiment(experiments: IAbUseExperiment[]): EBannerSimilarOffersExperiment {
  const experiment = experiments.find(exp => exp.experimentName === BANNER_SIMILAR_OFFERS);
  if (!experiment || !experiment.groupName) {
    return EBannerSimilarOffersExperiment.A;
  }

  return experiment.groupName as EBannerSimilarOffersExperiment;
}
